import numberUtils from 'app/shared/utils/numberUtils';

type DemographicFacts = {
  perCapitaIncome?: number | null;
  populationDensity?: number | null;
  medianHouseholdIncome?: number | null;
  population?: number | null;
  medianAge?: number | null;
  squareMiles?: number | null;
  percentRenters?: number | null;
};

type ParsedFact = {
  label: string;
  value: string;
};

export const useDemographics = (facts: DemographicFacts = {}) => {
  const parsedFacts: Array<ParsedFact> = [];

  if (facts.perCapitaIncome) {
    parsedFacts.push({
      label: 'Per capita income',
      value: `${numberUtils.asCurrency(facts.perCapitaIncome)}`,
    });
  }

  if (facts.populationDensity) {
    parsedFacts.push({
      label: 'Population density',
      value: `${numberUtils.truncateCompactedNumber(numberUtils.compact(facts.populationDensity), 0)} per square mile`,
    });
  }

  if (facts.medianHouseholdIncome) {
    parsedFacts.push({
      label: 'Median household income',
      value: `${numberUtils.asCurrency(facts.medianHouseholdIncome)}`,
    });
  }

  if (facts.population) {
    parsedFacts.push({
      label: 'Total population',
      value: `${numberUtils.fullNumber(facts.population)} people`,
    });
  }

  if (facts.medianAge) {
    parsedFacts.push({
      label: 'Median age',
      value: `${numberUtils.compact(facts.medianAge)} years old`,
    });
  }

  if (facts.squareMiles) {
    parsedFacts.push({
      label: 'Square miles',
      value: `${numberUtils.truncateCompactedNumber(numberUtils.compact(facts.squareMiles), 2)} square miles`,
    });
  }

  if (facts.percentRenters) {
    parsedFacts.push({
      label: 'Percent renters',
      value: `${numberUtils.asPercent(facts.percentRenters)}`,
    });
  }

  return { parsedFacts };
};
